function About() {
	return (
		<div className="p-8">
			<h2 className="text-4xl font-bold mb-6">About Telemix Company Limited</h2>
			<p className="mb-4 text-lg">
				Telemix is a leading ICT and infrastructure service provider in Nigeria,
				delivering innovative, reliable, and scalable solutions for businesses
				across multiple sectors.
			</p>
			<h3 className="text-2xl font-semibold mt-6 mb-2">Our Mission</h3>
			<p>
				To empower businesses with modern ICT solutions and reliable
				infrastructure, fostering growth and operational efficiency.
			</p>
			<h3 className="text-2xl font-semibold mt-6 mb-2">Our Vision</h3>
			<p>
				To be the preferred provider of integrated ICT and infrastructure
				services across Africa.
			</p>
		</div>
	);
}

export default About;
